<script>
export default {
    computed: {
        integrationsTabsSelected() {
            return this.integrationsTabs.filter(
                (x) => x.param === this.$store.getIntegrationsActionSelected
            )[0];
        },
        integrationsTabs() {
            return [
                {
                    id: 1,
                    title: "Pedidos",
                    param: "integrationsStatus",
                    show: true,
                    canBeHide: true,
                },
                {
                    id: 2,
                    title: "Tiendas",
                    param: "integrationByStore",
                    show: true, 
                    canBeHide: true,
                },
                // {
                //     id: 3,
                //     title: "Historial de pedidos",
                //     param: "ordersHistory",
                //     show: true,
                //     canBeHide: true,
                // },
            ];
        },
    },
    methods: {
        changeIntegrationsActionTo(action) {
            this.$store.setIntegrationsActionSelected(action);
            // Close mobile filter panel if it exists
            if (this.$parent && this.$parent.showTabs !== undefined) {
                this.$parent.showTabs = false;
            }
        },
    },
  
};
</script>
